import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { BrandLogo } from '@/context/BrandingContext';

export default function LandingNav({ extraNavItems = [] }) {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleScan = () => navigate('/onboarding');

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'backdrop-blur-md' : ''}`}
      style={{
        backgroundColor: scrolled ? 'rgba(237,232,223,0.95)' : 'transparent',
        borderBottom: scrolled ? '1px solid #D4C9B8' : '1px solid transparent',
      }}
      data-testid="landing-nav"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <div className="cursor-pointer" onClick={() => navigate('/')}>
          <BrandLogo
            slot={scrolled ? 'sidebar' : 'navbar_dark'}
            className="h-[34px]"
            fallback={
              <span className="text-[15px] font-semibold" style={{ color: scrolled ? '#3C3226' : '#F0EBE3' }}>
                GetChosenFirst
              </span>
            }
          />
        </div>
        <div className="hidden md:flex items-center gap-8">
          {extraNavItems.map(n => (
            <button key={n.label} onClick={n.action} className="transition-colors" style={{ color: scrolled ? '#5C5347' : '#F0EBE3', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 400 }}>{n.label}</button>
          ))}
          <button onClick={() => navigate('/pricing')} className="transition-colors" style={{ color: scrolled ? '#5C5347' : '#F0EBE3', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 400 }}>
            Pricing
          </button>
          <button onClick={() => navigate('/login')} className="transition-colors" style={{ color: scrolled ? '#3C3226' : '#F0EBE3', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.15em', fontWeight: 500 }} data-testid="nav-login-btn">
            Sign In
          </button>
        </div>
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden w-10 h-10 flex items-center justify-center" data-testid="mobile-menu-toggle">
          {mobileMenuOpen ? <X size={22} color={scrolled ? '#3C3226' : '#F0EBE3'} /> : <Menu size={22} color={scrolled ? '#3C3226' : '#F0EBE3'} />}
        </button>
      </div>
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="md:hidden overflow-hidden" style={{ backgroundColor: '#EDE8DF', borderBottom: '1px solid #D4C9B8' }}>
            <div className="p-6 space-y-4">
              {extraNavItems.map(n => (
                <button key={n.label} onClick={() => { setMobileMenuOpen(false); n.action(); }} className="block text-[13px] uppercase tracking-widest" style={{ color: '#3C3226' }}>{n.label}</button>
              ))}
              <button onClick={() => navigate('/pricing')} className="block text-[13px] uppercase tracking-widest" style={{ color: '#3C3226' }}>Pricing</button>
              <button onClick={() => navigate('/login')} className="block text-[13px] uppercase tracking-widest font-medium" style={{ color: '#3C3226' }}>Sign In</button>
              <button onClick={handleScan} className="w-full py-3 text-[12px] font-medium uppercase tracking-widest" style={{ backgroundColor: '#2C2520', color: '#F0EBE3' }}>Scan now</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
